// extracted by mini-css-extract-plugin
export default {"infoCard":"InfoCard_infoCard__wN0zM"};